import React from 'react';
import { cx } from '@/utils';
import { ButtonWithLogo } from '@common/ButtonWithLogo/ButtonWithLogo';
import Close from '@common/Icons/Close';
import { Dialog, DialogBody, DialogFooter, DialogHeader } from '@material-tailwind/react';

import { Button } from '@/components/ui/Button';

type Props = {
  show: boolean;
  onClose: () => void;
  title: string;
  description?: string;
  onConfirm: () => void;
  confirmationText?: string;
  children: React.ReactNode;
  className?: string;
};

const Overlay = ({
  show,
  onClose,
  onConfirm,
  title,
  description,
  children,
  className,
  confirmationText,
}: Props) => {
  return (
    <Dialog handler={onClose} open={show} className={cx(className, 'px-2')}>
      <DialogHeader className="flex w-full flex-col pb-0 text-left">
        <div className={'flex w-full items-center justify-between'}>
          <div className={'headline-h4 text-primary'}>{title}</div>
          <button onClick={onClose}>
            <Close width={13} height={13} className={'text-tundora'} />
          </button>
        </div>
        {description && <div className={'body-text1 w-full text-tundora'}>{description}</div>}
      </DialogHeader>
      <DialogBody>
        <div className={'px-2'}>{children}</div>
      </DialogBody>
      <DialogFooter>
        <div className="flex w-full items-center justify-end gap-2 px-2">
          <ButtonWithLogo
            onClick={onClose}
            className="cancel-button px-2 py-2"
            nameButton={'Cancelar'}
          />
          <ButtonWithLogo
            type="submit"
            onClick={onConfirm}
            className="confirm-button-blue px-2 py-2"
            nameButton={confirmationText || 'Guardar cambios'}
          />
        </div>
      </DialogFooter>
    </Dialog>
  );
};

export default Overlay;
